import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { MessagingService } from '@readygg/ng-api';
import * as AuthActions from '../actions/auth.actions';
import * as FcmActions from '../actions/fcm.actions';
import { selectCurrentFcmToken, selectPreviousFcmToken } from '../selectors/fcm.selectors';
import { withLatestFrom, switchMap, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '@env';
import { DeviceService } from '@app/core/services/device.service';
import { selectCurrentUserId, selectPreviousUserId } from '../selectors/auth.selectors';

@Injectable()
export class FcmEffects {
  updateTokenData$;

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private messagingService: MessagingService,
    private deviceService: DeviceService,
  ) {
    const appId = environment.projectId;

    this.updateTokenData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(AuthActions.authSuccess, AuthActions.logout, FcmActions.saveFcmToken),
        withLatestFrom(
          this.store.select(selectCurrentUserId),
          this.store.select(selectPreviousUserId),
          this.store.select(selectCurrentFcmToken),
          this.store.select(selectPreviousFcmToken),
        ),
        switchMap(([, currentUserId, previousUserId, currentFcmToken, previousFcmToken]) => {
          // Retrieve missing values from localStorage if necessary
          const actualUserId = currentUserId || '';
          const oldUserId = previousUserId || '';
          const actualToken = currentFcmToken || '';
          const oldToken = previousFcmToken || '';

          if (!actualUserId || !actualToken) {
            console.warn('Missing userId or actualToken; skipping token update.');
            return of(FcmActions.updateTokenDataFailure({ error: 'Missing userId or actualToken' }));
          }

          const deviceId = this.deviceService.getDeviceId();
          const params = {
            body: {
              appId: appId,
              actualUserId,
              oldUserId,
              actualToken,
              oldToken,
              deviceInfo: deviceId,
            },
          };

          return this.messagingService.messagingRefreshTokenData(params).pipe(
            map(() => FcmActions.updateTokenDataSuccess()),
            catchError((error) => of(FcmActions.updateTokenDataFailure({ error }))),
          );
        }),
      ),
    );
  }
}